import React, { useEffect, createElement } from 'react';
import { BrandHeader } from './components/sales/BrandHeader';
import { Hero } from './components/sales/Hero';
import { SocialProofBar } from './components/sales/SocialProofBar';
import { ProblemSection } from './components/sales/ProblemSection';
import { TomosGrid } from './components/sales/TomosGrid';
import { BonosTable } from './components/sales/BonosTable';
import { UrgencyCountdown } from './components/sales/UrgencyCountdown';
import { PricingPlans } from './components/sales/PricingPlans';
import { ComparisonTable } from './components/sales/ComparisonTable';
import { Testimonials } from './components/sales/Testimonials';
import { Guarantee } from './components/sales/Guarantee';
import { FAQ } from './components/sales/FAQ';
import { CostOfInaction } from './components/sales/CostOfInaction';
import { FinalCTA } from './components/sales/FinalCTA';
import { Footer } from './components/sales/Footer';
const META_PIXEL_ID = '950576387884513';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // If pixel already loaded, just track a PageView
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    // Initialize the fbq stub
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    // Load the Facebook events script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.body || document.documentElement).appendChild(script);
    // Initialize and fire PageView
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-base text-text-main font-sans selection:bg-primary/30 selection:text-text-main" data-id="element-0">
      <BrandHeader data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TomosGrid data-id="element-6" />
        <BonosTable data-id="element-7" />
        <UrgencyCountdown data-id="element-8" />
        <PricingPlans data-id="element-9" />
        <ComparisonTable data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <CostOfInaction data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}